module.exports = __webpack_public_path__ + "static/img/MonthCar.543305a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MonthCar.png
// module id = YAfG
// module chunks = 0